import { render } from "./PackageOptions.vue?vue&type=template&id=37abdd60&scoped=true"
import script from "./PackageOptions.vue?vue&type=script&lang=js"
export * from "./PackageOptions.vue?vue&type=script&lang=js"

import "./PackageOptions.vue?vue&type=style&index=0&id=37abdd60&scoped=true&lang=css"

import exportComponent from "/Users/timothyjoseph/Projects/simplest-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37abdd60"]])

export default __exports__